<div class="navbar-shortcut-container">
  <span class="navbar-shortcut__separator">|</span>
  <div class="navbar-shortcut">
    <cft-tab-pill [link]="link()" class="relative">
      @if (icon(); as icon) {
        <fa-icon [icon]="icon" />
      }
      <span class="navbar-shortcut__title">{{ title() }}</span>
      <ng-content select="cft-notification-bullet"></ng-content>
      <cft-tooltip class="navbar-shortcut__tooltip">{{ title() }}</cft-tooltip>
    </cft-tab-pill>
  </div>
</div>
